import { render, staticRenderFns } from "./UpdateVoucher.vue?vue&type=template&id=52185b91&scoped=true&"
import script from "./UpdateVoucher.vue?vue&type=script&lang=js&"
export * from "./UpdateVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52185b91",
  null
  
)

export default component.exports